import { render, staticRenderFns } from "./ParentDataTable.vue?vue&type=template&id=2ab5b0e4"
import script from "./ParentDataTable.vue?vue&type=script&lang=js"
export * from "./ParentDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports